/**
 * Google Analytics 4 (gtag.js) — solo web.
 *
 * En native (iOS/Android) no se carga nada. GA4 se usa para medir la PWA
 * (app.vuelto.ar) y trackear conversiones de Google Ads (registro de comercios).
 *
 * El Measurement ID se pasa por env var EXPO_PUBLIC_GA_MEASUREMENT_ID.
 * Si no está seteado, no se carga nada (no-op).
 */

const GA_MEASUREMENT_ID = process.env.EXPO_PUBLIC_GA_MEASUREMENT_ID;

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

let initialized = false;

/**
 * Inyecta el script de gtag.js y configura el Measurement ID.
 * Solo ejecuta en web y si el ID está seteado. Idempotente.
 */
export function initGA4(): void {
  if (initialized) return;
  if (typeof document === 'undefined') return;
  if (typeof window === 'undefined') return;
  if (!GA_MEASUREMENT_ID) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag(...args: unknown[]) {
    window.dataLayer.push(args);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID);

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  initialized = true;
}

/**
 * Envía un evento a GA4. No-op si GA4 no está inicializado.
 */
export function trackGA4Event(name: string, params?: Record<string, unknown>): void {
  if (!initialized || typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', name, params);
}
